module.exports = __webpack_public_path__ + "img/burger-menu-opened.5b3b25d.svg";